import React from 'react';
import { Card, Container, Row, Col } from 'react-bootstrap';

type PetInsuranceExample = {
  id: number;
  title: string;
  scenario: string;
  protection: string;
};

const petInsuranceExamples: PetInsuranceExample[] = [
  {
      "id": 1,
      "title": "Water Damage from Faulty Installation",
      "scenario": "A pipe you installed leaks and causes water damage to floors and drywall.",
      "protection": "General liability covers the resulting property damage (but not the faulty pipe itself)."
    },
    {
      "id": 2,
      "title": "Customer Slips on Wet Floor",
      "scenario": "A customer slips on a puddle left after your plumbing repair.",
      "protection": "Covers medical bills and legal claims for third-party bodily injury."
    },
    {
      "id": 3,
      "title": "Damage to Tile While Replacing Toilet",
      "scenario": "While removing an old toilet, you crack the surrounding tile.",
      "protection": "Covers the cost to repair or replace the damaged property."
    },
    {
      "id": 4,
      "title": "Bystander Injury at Job Site",
      "scenario": "A tenant trips over your hose while you're working in a multi-unit building.",
      "protection": "Covers third-party injuries caused by jobsite hazards."
    },
    {
      "id": 5,
      "title": "Flooding Due to Unattended Valve",
      "scenario": "You forget to turn off the water, flooding part of the client’s home.",
      "protection": "Pays for water damage restoration and related costs."
    },
    {
      "id": 6,
      "title": "Damage to Neighboring Apartment",
      "scenario": "A leak from a condo unit you worked on damages the unit below.",
      "protection": "Covers property damage to adjacent units or neighbors."
    },
    {
      "id": 7,
      "title": "Broken Fixture During Install",
      "scenario": "You accidentally drop and break a client’s expensive imported faucet.",
      "protection": "Covers replacement or repair of the damaged fixture."
    },
    {
      "id": 8,
      "title": "Drill Punctures Electrical Line",
      "scenario": "While installing a pipe, you puncture an unseen electrical line.",
      "protection": "May cover resulting damage or fire caused by the error."
    },
    {
      "id": 9,
      "title": "Trip Hazard from Tools",
      "scenario": "A homeowner trips on your wrench left in the hallway.",
      "protection": "Covers third-party medical bills and injury claims."
    },
    {
      "id": 10,
      "title": "Damage to Cabinets or Counters",
      "scenario": "Water spray damages wooden cabinetry during a sink installation.",
      "protection": "Covers property damage caused by work-related incidents."
    },
    {
      "id": 11,
      "title": "Client Files Frivolous Lawsuit",
      "scenario": "A client claims your work caused damage, but no fault is found.",
      "protection": "Still pays for legal defense, even if the case is dismissed."
    },
    {
      "id": 12,
      "title": "Advertising Injury from Website Content",
      "scenario": "A competitor sues for libel after you post a comparison chart online.",
      "protection": "Covers advertising injury such as libel, slander, or copyright infringement."
    },
    {
      "id": 13,
      "title": "Flooded Basement from Faulty Shutoff",
      "scenario": "You fail to test a shutoff valve, leading to basement flooding.",
      "protection": "Covers damage to floors, drywall, and furnishings."
    },
    {
      "id": 14,
      "title": "Cracked Foundation from Water Overflow",
      "scenario": "A misconnected drain line causes water to pool and crack the foundation.",
      "protection": "Covers repair costs for the property damage caused."
    },
    {
      "id": 15,
      "title": "Renter Injured During Repair",
      "scenario": "A tenant is injured by falling ceiling tiles dislodged during plumbing work.",
      "protection": "Pays for injuries resulting from incidental damage or disturbances."
    },
    {
      "id": 16,
      "title": "Client Claims Delays Caused Loss",
      "scenario": "A business owner sues because your delay allegedly caused them lost revenue.",
      "protection": "General liability may help defend against the claim, though E&O coverage is often needed too."
    },
    {
      "id": 17,
      "title": "Damage to Rented Equipment",
      "scenario": "You rent a drain jetter for a big job and it gets damaged during use.",
      "protection": "General liability may cover damage to non-owned equipment (if included in policy)."
    },
    {
      "id": 18,
      "title": "Sewage Backup Causes Property Damage",
      "scenario": "An improper install leads to sewage backing up into a customer’s home.",
      "protection": "Covers cleanup costs and damage caused by the backup."
    },
    {
      "id": 19,
      "title": "Fire from Water Heater Installation",
      "scenario": "A faulty install leads to a small fire in the utility room.",
      "protection": "Covers fire damage and any third-party property claims."
    },
    {
      "id": 20,
      "title": "Client Claims You Damaged Antique Flooring",
      "scenario": "A client accuses you of damaging their 100-year-old wood floor while repairing a pipe.",
      "protection": "General liability helps cover investigation and repair costs."
    }
  // ... Add all 20 entries here
];

const InsuranceExample: React.FC = () => {
  return (
    <Container className="my-4">
      <h2 className="mb-4 text-center">HARD CODED - TO FIX - How Pet Insurance Protects You</h2>
      <Row>
        {petInsuranceExamples.map((example) => (
          <Col md={6} lg={4} className="mb-4" key={example.id}>
            <Card className="h-100 shadow-sm">
              <Card.Body>
                <Card.Title>{example.id}. {example.title}</Card.Title>
                <Card.Text><strong>Scenario:</strong> {example.scenario}</Card.Text>
                <Card.Text><strong>Protection:</strong> {example.protection}</Card.Text>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </Container>
  );
};

export default InsuranceExample;
